export const experienceData = [
    {
        id: 1,
        company: 'Neudhi23 Pvt. Ltd.',
        jobtitle: 'System Engineer',
        startYear: '2023',
        endYear: 'Present'
    },
    {
        id: 2,
        company: 'Mobiloitte Technologies',
        jobtitle: 'Intern',
        startYear: '2022',
        endYear: '2023'
    },
]